// @flow
import React from 'react';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import './FileUpload.css';

export type Props = {
  upload: Object,
  onUploadAbort: Function,
};

const FileUpload = ({upload, onUploadAbort}: Props) => (
  <div className="FileUpload row no-row-margins expand">
    {upload.error ?
      <div className="file-error column">
          Filen kunde inte laddas upp
      </div>
      :
      <div className="loading-progress column">
        <LoadingIndicator isLoading={true} progress={upload.progress} />
      </div>
    }
    <button
      onClick={() => onUploadAbort()}
      type="button"
      className="button column shrink">
      <i className="fa fa-times"></i>
    </button>
  </div>
);

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/FileUpload/FileUpload.js